import React from 'react';

function About() {
  return (
    <div>
      <h1>About This App</h1>
      <p>This app demonstrates a dynamic React application with routing and reusable components.</p>
    </div>
  );
}

export default About;
